import { call, put, takeLatest, all } from "redux-saga/effects";
import { completeTripApi, getCompleteBookingByDateApi } from "../../utils/booking/Complete";
import {
    COMPLETE_TRIP_REQUEST,
    COMPLETE_TRIP_SUCCESS,
    COMPLETE_TRIP_FAILURE,
    GET_COMPLETE_BOOKING_BY_DATE_SUCCESS,
    GET_COMPLETE_BOOKING_BY_DATE_FAILURE,
    GET_COMPLETE_BOOKING_BY_DATE_REQUEST,
} from "../actions/completeAction";

function* completeTripSaga(action: any): any {
    try {
        const response = yield call(completeTripApi, action.payload);

        if (response.data.status !== 200) {
            yield put({
                type: COMPLETE_TRIP_FAILURE,
                payload: response.data.message || "Failed to complete trip",
            });
            return;
        }

        yield put({
            type: COMPLETE_TRIP_SUCCESS,
            payload: response.data,
        });
    } catch (error: any) {
        yield put({
            type: COMPLETE_TRIP_FAILURE,
            payload: error.response?.data?.message || "Failed to complete trip",
        });
    }
}

function* getCompleteBookingByDateSaga(action: any): any {
    try {
        const response = yield call(getCompleteBookingByDateApi,
            action.payload.branchid,
            action.payload.fromdate,
            action.payload.todate
        );

        const res = response.data;
        const bookings =
            Array.isArray(res?.data?.data) ? res.data.data
                : Array.isArray(res?.data) ? res.data
                    : Array.isArray(res) ? res
                        : [];

        yield put({
            type: GET_COMPLETE_BOOKING_BY_DATE_SUCCESS,
            payload: {
                bookings, tablelength: res?.data?.tablelength || 0,
                totalamount: res?.data?.totalamount || 0,
            }
        });
    } catch (error: any) {
        yield put({
            type: GET_COMPLETE_BOOKING_BY_DATE_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch complete bookings",
        });
    }
}

export default function* completeSaga() {
    yield all([
        takeLatest(COMPLETE_TRIP_REQUEST, completeTripSaga),
        takeLatest(GET_COMPLETE_BOOKING_BY_DATE_REQUEST, getCompleteBookingByDateSaga),
    ]);
}
